module.exports = __webpack_public_path__ + "media/brands/toyota-5725cd87.png";